import Image from 'next/image';

import { cn } from '@/utils/app.utils';
import { APP_NAME, SOCIALS } from '@/utils/constants';

type Props = {
  className?: string;
};

const Socials = ({ className }: Props) => {
  return (
    <div
      className={cn(
        'flex flex-row items-center justify-center gap-2 self-stretch',
        className
      )}
    >
      {SOCIALS.map((social, index) => (
        <a key={index} href={social.value}>
          <div className="flex h-[42px] w-[42px] flex-row items-center justify-center rounded bg-default">
            {/* light */}
            <Image
              alt={`${APP_NAME} ${social.label}`}
              className="block w-[24px] dark:hidden"
              height="24"
              src={`/icons/${social.label}.svg`}
              width="24"
            />
            {/* dark */}
            <Image
              alt={`${APP_NAME} ${social.label}`}
              className="hidden w-[24px] dark:block"
              height="24"
              src={`/icons/${social.label}-dark.svg`}
              width="24"
            />
          </div>
        </a>
      ))}
    </div>
  );
};

export default Socials;
